export const newReleaseData = [];

export const productPreviewData = [
  {
    name: "FULLNESS",
    title: "HOODIE",
    image: require("../../images/design-photos/fullnesstilephoto.jpg"),
    index: 11,
  },
  {
    name: "WALK ON WATER",
    title: "STICKER",
    image: require("../../images/design-photos/bottle-graphic.jpg"),
    index: 9,
  },
  {
    name: "SPERO BEAR",
    title: "STICKER",
    image: require("../../images/design-photos/bear-graphic.jpg"),
    index: 7,
  },
  {
    name: "MOUNTAIN MOVER",
    title: "STICKER",
    image: require("../../images/design-photos/mountain-graphic.jpg"),
    index: 8,
  },
  {
    name: "REDEEMED",
    title: "HOODIE",
    image: require("../../images/design-photos/redeemed-left.jpg"),
    index: 10,
  },
  {
    name: "ABIDE",
    title: "HOODIE",
    image: require("../../images/design-photos/abide-window.jpg"),
    index: 6,
  },
  {
    name: "HOPE",
    title: "LONGSLEEVE",
    image: require("../../images/design-photos/hope-longsleeve.jpg"),
    index: 5,
  },
  {
    name: "I AM THAT GIRL",
    title: "HAT",
    image: require("../../images/design-photos/girl-hat-top.jpg"),
    index: 4,
  },
  {
    name: "MACRON",
    title: "HOODIE",
    image: require("../../images/design-photos/macron-hoodie-guy.jpg"),
    index: 3,
  },
  {
    name: "BLESSED TO BLESS",
    title: "SHIRT",
    image: require("../../images/design-photos/blessed-horizontal.jpg"),
    index: 2,
  },
  {
    name: "BAY AREA",
    title: "LONG SLEEVE",
    image: require("../../images/design-photos/bay-area-main.jpg"),
    index: 1,
  },
  {
    name: "BERKELEY",
    title: "HOODIE",
    image: require("../../images/design-photos/berkeley-horizontal.jpg"),
    index: 0,
  },
];
